'use client'

import { useTheme } from '@/contexts/ThemeContext'
import { SunIcon, MoonIcon } from './icons/SocialIcons'

export default function ThemeSwitcher() {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="w-10 h-10 bg-accent/20 hover:bg-accent/30 border border-accent/50 hover:border-accent transition-all duration-200 flex items-center justify-center cursor-pointer group"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
    >
      {theme === 'light' ? (
        <MoonIcon className="w-5 h-5 text-accent group-hover:scale-110 transition-transform" />
      ) : (
        <SunIcon className="w-5 h-5 text-accent group-hover:scale-110 transition-transform" />
      )}
    </button>
  )
}

